import { type FC } from "react";
import { useNavigate } from "react-router";

import { faArrowLeft } from "@fortawesome/pro-duotone-svg-icons/faArrowLeft";
import { faHome } from "@fortawesome/pro-duotone-svg-icons/faHome";
import { faLock } from "@fortawesome/pro-duotone-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Button } from "@styled/button";
import { ButtonLink } from "@styled/button_link";
import { CenteredPage } from "@styled/centered_page";
import { Panel } from "@styled/panel";
import { PanelControls } from "@styled/panel_controls";
import { PanelSection } from "@styled/panel_section";
import { PanelSubtitle } from "@styled/panel_subtitle";
import { PanelTitle } from "@styled/panel_title";

export const AccessDenied: FC = () => {
  const navigate = useNavigate();

  return (
    <CenteredPage>
      <Panel>
        <PanelSection>
          <FontAwesomeIcon icon={faLock} size="2x" />
        </PanelSection>

        <PanelSection>
          <PanelTitle>You don't have access to this page</PanelTitle>
          <PanelSubtitle>
            Contact your workspace admin if you think you should have access.
          </PanelSubtitle>
        </PanelSection>

        <PanelSection>
          <PanelControls>
            <Button color="white" onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon={faArrowLeft} />
              Go back
            </Button>

            <ButtonLink to="/dashboard" color="indigo">
              <FontAwesomeIcon icon={faHome} />
              Dashboard
            </ButtonLink>
          </PanelControls>
        </PanelSection>
      </Panel>
    </CenteredPage>
  );
};
